import { Attr, IndexedMesh }  from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


export type UVAttr = { uv: Attr };

export class ScaleUV<T extends UVAttr> extends IndexedMeshWriter<T> {

    /** The amount by which to scale the u coordinate */
    u: number;

    /** The amount by which to scale the v coordinate */
    v: number;

    /** The mesh to  */
    writer: IndexedMeshWriter<T>;

    /**
     * Scales the UV coordinates along the U and V (2D X and Y) axes by the
     * given amounts.
     */
    constructor(u: number, v: number, writer: IndexedMeshWriter<T>) {
        super();
        this.u = u;
        this.v = v;
        this.writer = writer;
    }

    computeAttributeCounts(): IndexedMesh<T> {
        return this.writer.computeAttributeCounts();
    }

    computeMeshData(result: IndexedMesh<T>): void {
        this.writer.computeMeshData(result);
        if(result.attrs.uv == null) {
            return;
        }

        const
            u = this.u,
            v = this.v,
            uv = result.attrs.uv.data;

        let i = 0;
        while(i < uv.length) {
            uv[i++] *= u;
            uv[i++] *= v;
        }
    }
}
